'use strict';

describe('@fremcast/section', () => {
    it('needs tests');
});
